
export function getShareText(
  gameState: "perfect" | "almost" | "wrong", 
  solveTime: number | null, 
  attempts: number, 
  selectedWords?: Array<{ word: any; order: number }>, 
  targetOrder?: any[],
  attemptId?: string // New parameter for the attempt ID
): string {
  // Create result line based on game state
  let resultLine = "";
  
  // For emoji line generation later
  let emojiLine = "";

  if (gameState === "perfect") {
    resultLine = "I got perfect logic today!";
  } else {
    // For "wrong" and "almost" and others, new unified format
    resultLine = "I just played Match My Logic.";
  }
  
  // Generate emoji line based on word matches if we have the data
  if (selectedWords && targetOrder && selectedWords.length > 0 && targetOrder.length > 0) {
    console.log("Generating emoji line with:", { selectedWords, targetOrder });
    
    // Sort selected words by order
    const orderedSelectedWords = [...selectedWords]
      .sort((a, b) => a.order - b.order)
      .map(item => item.word);
    
    // Compare each word with target order
    emojiLine = orderedSelectedWords.map((word, index) => {
      if (index >= targetOrder.length) return "⚪️"; // white circle fallback
      return word === targetOrder[index] ? "🟢" : "⚪️"; // green or white circles
    }).join(" ");
    
    console.log("Generated emoji line:", emojiLine);
  } else {
    // Fallback emoji line based on state
    console.log("Using fallback emoji pattern for state:", gameState);
    emojiLine = gameState === "perfect" ? 
      "🟢 🟢 🟢 🟢 🟢" : 
      "🟢 🟢 ⚪️ ⚪️ ⚪️"; // same fallback line for "wrong", "almost" etc
  }
  
  // Create the base URL for the player card (using window.location.origin)
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://daily.matchmylogic.com';
  
  // Add player card URL if we have an attempt ID
  const playerCardUrl = attemptId ? `${baseUrl}/player-card/${attemptId}` : '';
  
  // Combine all parts with the website link and player card link
  let shareText = "";
  
  if (gameState === "perfect") {
    shareText = `${resultLine}\n${emojiLine}\nLock in! daily.matchmylogic.com`;
  } else {
    // For all other results, new format with website link
    shareText = `${resultLine}\n${emojiLine}\nWill you match me or the game? Lock in! daily.matchmylogic.com`;
  }
  
  // Add player card link if available
  if (playerCardUrl) {
    shareText += `\nSee my Player Card: ${playerCardUrl}`;
  }

  console.log("Final share text:", shareText);
  return shareText;
}
